export default __webpack_public_path__ + "static/media/MoreOptions.5c5670f9.svg";